export default __webpack_public_path__ + "static/media/download.67aa1a11.svg";